import { render } from "./MyPageView.vue?vue&type=template&id=60f83af6&scoped=true"
import script from "./MyPageView.vue?vue&type=script&lang=js"
export * from "./MyPageView.vue?vue&type=script&lang=js"

import "./MyPageView.vue?vue&type=style&index=0&id=60f83af6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60f83af6"

export default script